// extracted by mini-css-extract-plugin
module.exports = {"card":"dh-dh-klima-spesial-card--f554ca6ae78be9eeb2a22e3799d0ad7b","cardActive":"dh-dh-klima-spesial-cardActive--c56bae1c79edfb153cd5032ed3e40ebd"};